module.exports = __webpack_public_path__ + "fonts/muuq-fonts.7450629c.ttf";